import 'bootstrap/dist/css/bootstrap.css';
global.jQuery = require('jquery');
require('bootstrap');

import '../sass/main.scss';

import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';

import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

import 'calc-polyfill/calc.min';
import 'picturefill';

import 'jquery-mask-plugin';


jQuery(document).ready(function($){ 

    $('.owl-departamentos').owlCarousel({
        loop:true,
        margin:30,
        nav:true,
        dots:false,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        items:3,
        responsive:{
            0:{
                items:1,
                margin:10,
            },
            600:{
                items:2,
            },            
            1024:{
                items:3,
            },
            1600:{
                margin:20,
            }
        }
    });

    $(window).scroll(function() {  
        if ($(window).scrollTop() > 120) { 
          $('#head').addClass("fixed");
        } else {
          $('#head').removeClass("fixed");
        } 
    }); 

    $('.telefone').mask('(00) 0000-00009');

    //$('.js-example-basic-single').select2();
    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });
 
    $('.hamburger-menu, .close').click(function(){
        $(this).toggleClass('active');
        $('#head').toggleClass('active');
    });

    $('li.menu-item-has-children').click(function(){
        $(this).toggleClass('active');
    });

});